import React from 'react';
import './ProfileCard.css';
import {useAppSelector} from "../../../redux/hooks";
import {profilePackagesByProfileIdSelector} from "../../../redux/profile-packages";
import {
    IonAccordionGroup,
    IonBadge,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle
} from "@ionic/react";
import {Booking, Customer, Profile} from "../../../models";
import ProfilePackageAccordion from "../ProfilePackageAccordion/ProfilePackageAccordion";
import {formatFreezeDate} from "../../../utils/frozen";

export interface ProfileCardProps {
    profile: Profile;
    customer: Customer;

    setSelectedBooking: (booking?: Booking) => void;
}

const ProfileCard: React.FC<ProfileCardProps> = (props) => {
    const {profile, customer, setSelectedBooking } = props;

    const profilePackagesByLearnerId = useAppSelector((state) => profilePackagesByProfileIdSelector(state, profile.id))

    return (
        <IonCard className={"ion-text-left profile-card"} key={`profile-${profile.id}`}>
            <IonCardHeader>
                <IonCardTitle className={'profile-card-title'}>
                    {profile.fullName}
                </IonCardTitle>
                {profile.level && <IonCardSubtitle>{profile.level.name}</IonCardSubtitle>}
                {profile.frozenUntil &&
                    <IonBadge color={"medium"} className={"ion-margin-top"}>
                        Frozen until {formatFreezeDate(profile.frozenUntil)}
                    </IonBadge>
                }
            </IonCardHeader>
            <IonCardContent className={"ion-no-padding"}>
                {
                    <IonAccordionGroup>
                        {
                            profilePackagesByLearnerId && profilePackagesByLearnerId.map((profilePackage, index) => (
                                <ProfilePackageAccordion
                                    key={`profile-package-accordion-${profilePackage.id}`}
                                    profilePackage={profilePackage}
                                    frozenUntil={profile.frozenUntil}
                                    setSelectedBooking={setSelectedBooking}
                                    useSelfBooking={customer?.company?.useSelfBooking}
                                    useClasses={customer?.company?.useClasses}
                                    company={customer.company}
                                ></ProfilePackageAccordion>
                            ))
                        }
                    </IonAccordionGroup>
                }
            </IonCardContent>
        </IonCard>
    );
};

export default ProfileCard;
